<template>
    <el-dialog :visible.sync="show" width="600px" append-to-body :before-close="closeDialog">
        <div class="form-box">
            <div class="recharge-span">选择支付金额</div>
            <div class="recharge-btn">
                <el-button
                :class="{'active':btnChangeIndex == index}"
                    type="info"
                    @click="numChange(item, index)"
                    v-for="(item, index) in rechargeData"
                    :key="index"
                    >{{ item }}</el-button
                >
            </div>
            <!-- <div>
                <el-button
                type="primary"
                :plain="btnChangeIndex == index ? false : true"

                    @click="numChange(item, index)"
                    v-for="(item, index) in rechargeData"
                    :key="index"
                    >{{ item }}</el-button
                >

            </div> -->

            <div class="recharge-span" v-if="give_amount>0">
                一次性满<span style="color: #05c0ab">{{ submit_data.amount }}</span
                >元赠送<span style="color: #05c0ab">{{ give_amount }}</span
                >元服务费
            </div>
            <div style="display: flex; align-items: center; flex-direction: column; margin-top: 20px">
                <h1 style="font-size: 30px; color: #05c0ab">请用微信扫码付款</h1>
                <el-image :src="wxpayUrl" v-loading="loading">
                    <div slot="error">加载中<span class="dot">...</span></div>
                </el-image>
                <div>注：若二维码过期失效，请重新选择要充值的金额进行支付！</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
var _this;
let myTimer;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;

            _this.default100(); //打开页面，充值默认为100；
        }
    },
    data() {
        return {
            loading: false,
            rechargeData: ['100', '300', '500', '800', '1000', '1500', '2000', '3000','7800','0.01'],
            give_amount: '',
            show: false,
            wxpayUrl: '',

            // 表单数据
            submit_data: {
                amount: '',
                trade_type:'T_MINIAPP'
            },
            btnChangeIndex: '0' //防止进入充值页面，充值金额默认为100
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 默认充值金额100元
        default100() {
            _this.submit_data.amount = '100';

            _this.handlePayWxQRcode();
        },

        // 选择充值金额
        numChange(val, index) {
            this.loading = true;

            this.btnChangeIndex = index;

            _this.submit_data.amount = val;

            _this.handlePayWxQRcode();
        },
        //获取充值二维码
        handlePayWxQRcode() {
            _this.$post('/service_fee/rechargeToHuifu', this.submit_data).then((res) => {
                _this.wxpayUrl = res.data.qr_img;
                this.loading = false;
                _this.give_amount = res.data.give_amount;
                console.log(_this.give_amount, '_this.give_amount');

                _this.payStatus(res.data.parameter.trade_no);
            });
        },
        // 轮询,定时器查询支付状态，如果状态不是完成，每3秒查询一下状态，如果状态为完成，则关闭充值二维码页面
        payStatus(val) {
            clearTimeout(myTimer);
            // axios.defaults.baseURL = config.axios_normalURL;

            _this.$post('/wechat/payStatus', { trade_no: val },{},'normal').then((res) => {
                // axios.defaults.baseURL = config.axios_baseURL; //请求base url

                if (res.data.status != '1') {
                    myTimer = setTimeout(() => {
                        _this.payStatus(val);
                    }, 3000);
                } else {
                    _this.$emit('onSubmit');

                    _this.closeDialog();
                }
            });
            // axios.defaults.baseURL = config.axios_baseURL; //请求base url
        },

        // 关闭方法
        closeDialog() {
            clearTimeout(myTimer);
            console.log(111);
            _this.show = false;

            _this.give_amount = '';
            _this.wxpayUrl = '';


            _this.submit_data = {
                amount: '',
                trade_type:'T_MINIAPP'
            };

            this.btnChangeIndex = '0';
        }
    }
};
</script>
<style scoped>
.el-button{
    border: 1px solid #21A7EA!important;
    color: #21A7EA!important;
}
.active{
    background: #21A7EA!important;
    color: #fff!important;
    border: 1px solid #21A7EA!important;
}
.recharge-btn {
    display: flex;
    flex-wrap: wrap;

}
.recharge-btn .el-button{
    width: 19%;
    margin: 10px 2px!important;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
}
.recharge-span {
    font-size: 18px;
    margin: 10px 0;
}
</style>
<style>
.recharge-btn .el-button--info {
    border: 1px solid #05c0ab;
    background-color: #fff;
    color: #05c0ab;
}
.form-box .el-image__inner {
    width: 220px;
}
</style>
